import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { createAri } from '@atlassian/jira-platform-ari/src/index.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from '@atlassian/jira-capacity/src/ui/__generated__/ui_jiraCapacityQuery$parameters';

export const capacityEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-jira-capacity" */ './src'),
	),
	getPreloadProps: (entryPointRouteParams: EntryPointRouteParams) => {
		const {
			context: { match },
			tenantContext,
		} = entryPointRouteParams;

		const sourceAri = createAri({
			resourceOwner: 'jira-software',
			cloudId: tenantContext.cloudId,
			resourceType: 'board',
			resourceId: match.params.boardId ?? '',
		});

		return {
			queries: {
				capacityData: {
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
					parameters,
					variables: {
						cloudId: tenantContext.cloudId,
						id: sourceAri,
					},
				},
			},
			entryPoints: {},
			extraProps: {
				tenantContext,
			},
		};
	},
});
